import * as React from "react";
//#region types
import { TranslationKeys } from "translations";
import { QrCodeProps } from "models/propTypes/loginPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import QRCode from "react-qr-code";
import { StyledButton } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const BankIdQRCode: React.FC<QrCodeProps> = (props) => {
  const size = props.size ?? 256;
  return (
    <Grid container spacing={4}>
      <Grid item container columns={3} spacing={2}>
        <Grid item xs></Grid>
        <Grid item>
          <QRCode
            size={size}
            style={{ height: "auto", width: "100%", maxWidth: `${size}px` }}
            value={props.qrCodeData}
            viewBox={`0 0 ${size} ${size}`}
          />
        </Grid>
        <Grid item xs></Grid>
      </Grid>
      <Grid item container className={cssExports.loadingText}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.BankIdLoginMessage)}
      </Grid>

      {props.cancelLoadingText && (
        <Grid item container>
          <StyledButton onClick={props.onLoadingCancelHandler} secondary className={cssExports.loginButton}>
            {LocalizationHelperInstance.getFormattedMessage(props.cancelLoadingText)}
          </StyledButton>
        </Grid>
      )}
    </Grid>
  );
};

export default BankIdQRCode;
